module.exports = __webpack_public_path__ + "static/media/wave-sine.8f555616.svg";